module.exports = __webpack_public_path__ + "static/media/wash-fold.f94c7281.jpg";